module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-ecostruxure-quote.c3cb170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-ecostruxure-quote.jpg
// module id = 7pQt
// module chunks = 0